import React, { useEffect, useState } from 'react';
import { LegalModal } from './legalModal.jsx';
import { reduxConnect } from '../../common';
import { getLegalPolicies } from '../../common/actions/legalActions';

const mapStoreStateToProps = (storeState) => {
    const { countryCode, languageCode, stdParameters, legalBaseUrl, authId, secret, allowStorageOrCookieAccess } = storeState.appState.appState || {};
    const { complianceRequirements, legalPolicy } = storeState.legal || {};
    return {
        countryCode,
        languageCode,
        stdParameters,
        legalBaseUrl,
        authId,
        secret,
        complianceRequirements,
        legalPolicy,
        allowStorageOrCookieAccess
    };
};

const mapDispatchToProps = {
    getLegalPolicies
};

export const TermsAndPrivacyUpdate = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    countryCode, languageCode, stdParameters, complianceRequirements, legalPolicy, getLegalPolicies, legalBaseUrl, authId, secret, allowStorageOrCookieAccess
}) => {

    const [ selectedUrl, setSelectedUrl ] = useState();
    const [ visible, setVisible ] = useState(false);
    const [ modalVisible, setModalVisible ] = useState(false);

    //TECHDEBT: When locale is supported we will need to re-call the compliance API on changes.
    useEffect(() => {
        if (countryCode && languageCode && legalBaseUrl && authId && secret && stdParameters) {
            try {
                // Have to pass null as a string when it isn't set or the api will complain
                getLegalPolicies(
                    'null',
                    'null',
                    countryCode,
                    languageCode,
                    legalBaseUrl,
                    authId,
                    secret,
                    stdParameters
                );
            } catch(error) {
                console.log(error);
            }
        }
    }, [countryCode, languageCode, legalBaseUrl, authId, secret, stdParameters]);

    useEffect(() => {
        if (complianceRequirements && legalPolicy && allowStorageOrCookieAccess) {
            setVisible(legalPolicy?.tou?.display || legalPolicy?.pp?.display);
        }
    }, [complianceRequirements, legalPolicy, allowStorageOrCookieAccess]);

    const hide = () => {
        setVisible(false);
    };

    const changeModalVisibility = () => {
        setModalVisible(!modalVisible);
    };

    const selectUrl = (selectedUrl) => {
        setSelectedUrl(selectedUrl);
        setModalVisible(true);
    };

    const getPolicyMessage = (policy) => {
        if (policy.display) {
            return (
                <span>
                    {' ' + policy.message}
                    {getPolicyLink(policy.url)}
                </span>
            );
        }
        return null;
    };

    const getPolicyLink = (url) => {
        return (
            <span
                style={styles.link}
                onClick={() => {
                    selectUrl(url);
                }}
            >
                {legalPolicy.linkText}
            </span>
        );
    };

    const getMessage = (legalPolicy) => {
        const { tou, pp } = legalPolicy;
        if (legalPolicy.message) {
            let messages = [legalPolicy.message];
            for (let key in legalPolicy) {
                if (legalPolicy[key].url) {
                    const keyIndex = messages.findIndex(
                        message =>
                            typeof message === 'string' && message.includes('[' + key + ']')
                    );
                    if (keyIndex >= 0) {
                        let update = messages[keyIndex].split('[' + key + ']');
                        update.splice(1, 0, getPolicyLink(legalPolicy[key].url));
                        messages.splice(keyIndex, 1, ...update);
                    }
                }
            }
            return messages.map((message, index) => {
                return <span key={index}>{message}</span>;
            });
        } else {
            return (
                <span>
                    {getPolicyMessage(tou)}
                    {getPolicyMessage(pp)}
                </span>
            );
        }
    };

    // TODO: Implement cookies so we can log what users have agreed to and we can unhide it and this won't show anymore.
    return (
        visible &&
        <div style={styles.container}>
            <div style={styles.textContainer}>
                <span style={styles.text}>{getMessage(legalPolicy)}</span>
            </div>
            <div
                style={styles.closeContainer}
                onClick={() => {
                    hide();
                }}
            >
                <svg
                    style={styles.closeButton}
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 12.7 12.7"
                    enableBackground="new 0 0 12.7 12.7"
                    xmlSpace="preserve"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.3,11.2c-0.3,0.3-0.3,0.9,0,1.2l0,0c0.3,0.3,0.9,0.3,1.2,0l11-11
                        c0.3-0.3,0.3-0.9,0-1.2l0,0c-0.3-0.3-0.9-0.3-1.2,0L0.3,11.2L0.3,11.2z M0.3,11.2"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5,11.2c0.3,0.3,0.3,0.9,0,1.2l0,0c-0.3,0.3-0.9,0.3-1.2,0l-11-11
                        c-0.3-0.3-0.3-0.9,0-1.2l0,0c0.3-0.3,0.9-0.3,1.2,0L12.5,11.2L12.5,11.2z M12.5,11.2"
                    />
                </svg>
            </div>
            {modalVisible && (
                <LegalModal
                    close={() => {
                        changeModalVisibility();
                    }}
                    sourceUrl={selectedUrl}
                />
            )}
        </div>
    );
});

const styles = {
    container: {
        minHeight: 30,
        width: '100%',
        zIndex: 99,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: 8,
        display: 'none',
        alignItems: 'center'
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: 30
    },
    text: {
        color: '#FFFFFF',
        fontSize: 13,
        paddingLeft: 12,
        paddingRight: 12
    },
    link: {
        color: '#FFFFFF',
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    closeButton: {
        stroke: '#FFFFFF',
        fill: '#FFFFFF',
        width: 12,
        height: '100%'
    },
    closeContainer: {
        float: 'right',
        width: 12,
        height: 12,
        cursor: 'pointer'
    }
};
